import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  footer: {
    paddingBottom: 120
  },
  button: {
    position: 'absolute',
    right: 15,
    top: 26,
    width: '200px !important'
  }
}))

export {
  useStyles
}